import React from 'react';
import Button from 'src/components/10-atoms/button/Button';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import Column from 'src/components/10-atoms/layout/Column';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import { NodeType } from 'src/modules/exam-preparation/graphql/common/types/node';
import styleUtils from 'src/utils/styles';
import QPList from '../QPList';
const QPTab = ({ subjectID, subject, onQPPress, onAddQuestionPaper, style, ...columnProps }) => {
    const [{ deviceType }] = useTheme(stylesGenerator);
    return (React.createElement(Column, { style: [styleUtils.flex, style], ...columnProps },
        React.createElement(QPList, { containerStyle: [styleUtils.flex], contentContainerStyle: [
                styleUtils.spaceBtwHeadNBody,
                !deviceType.isDesktop && styleUtils.floatingBtnGutter,
            ], subjectID: subjectID, onQPPress: onQPPress, groupBy: subject?.type === NodeType.WRITTEN_SUBJECT ? 'year' : 'month', subjectType: subject?.type ?? NodeType.WRITTEN_SUBJECT }),
        !deviceType.isDesktop && (React.createElement(Button, { variant: "float", LeftIcon: props => React.createElement(FeatherIcon, { name: "plus", ...props }), onPress: onAddQuestionPaper }, "Question Paper"))));
};
const stylesGenerator = createThemedStyle(({}) => ({}));
export default QPTab;
